import Avatar from "components/Home/ui/Avatar";
import React from "react";
import RemoteMediaStatus from "./RemoteMediaStatus/RemoteMediaStatus";

const MediaInfo = ({ person, visual, membersMuted }) => {
  const {
    avatar_key,
    given_name,
    family_name,
    mutedForMe,
    micOn,
    camOn,
    share,
    shout,
    pinnedShare,
    admin,
  } = person;

  return (
    <div className={`media-info`}>
      <RemoteMediaStatus
        mutedForMe={mutedForMe}
        micOn={micOn}
        camOn={camOn}
        share={share}
        visual={visual}
        shout={shout}
        pinnedShare={pinnedShare}
        admin={admin}
        membersMuted={membersMuted}
      />
      <div className={`video-bar-avatar`}>
        <Avatar
          // avatar_key={null}
          // given_name={luid[0]}
          // family_name={luid[1] ? luid[1] : " "}
          avatar_key={avatar_key}
          given_name={given_name}
          family_name={family_name}
        />
      </div>
    </div>
  );
};

export default MediaInfo;
